"use client";

import { Mail, Phone, PhoneCall } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Secretariatcontact() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const grid = useRevealOnScroll<HTMLDivElement>();
  const footer = useRevealOnScroll<HTMLDivElement>();
  const channels = [{
    type: "emergency",
    icon: PhoneCall,
    label: "[ HOTLINE REDAKSI ]",
    heading: "Berita Mendesak? Kejadian Penting?",
    contact: "0812-ABADI-NEWS",
    contactHref: "tel:+628122223234",
    hours: "24 jam · 7 hari"
  }, {
    type: "general",
    icon: Phone,
    label: "[ KANTOR PUSAT ]",
    heading: "Pertanyaan? Kerjasama?",
    contact: "(021) 888-9999",
    contactHref: "tel:+62218889999",
    hours: "Senin–Jumat 09:00–17:00"
  }, {
    type: "email",
    icon: Mail,
    label: "[ EMAIL REDAKSI ]",
    heading: "Kirim rilis atau liputan",
    contact: "redaksi@abadi.news",
    contactHref: "mailto:redaksi@abadi.news",
    hours: "Respon dalam 4 jam kerja"
  }];
  return <section data-section-id="855" id="secretariatcontact" className="bg-background text-foreground" style={{
    backgroundColor: "hsl(0, 0%, 98%)"
  }}>
      <div className="mx-auto max-w-7xl px-6 py-20 sm:py-24 lg:px-8 lg:py-28">
        {}
        <div ref={header.ref} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs sm:text-sm tracking-[0.25em] uppercase mb-6" style={{
          color: "hsl(25, 83%, 55%)"
        }}>
            [ KONTAK ABADI.NEWS ]
          </p>
          <h2 className="font-serif font-default text-foreground leading-[1.05]" style={{
          fontSize: "clamp(2.5rem, 5vw, 4rem)"
        }}>
            Ingin{" "}
            <span className="italic" style={{
            color: "hsl(25, 83%, 55%)"
          }}>
              terhubung langsung?
            </span>
          </h2>
          <p className="mt-6 font-default text-base sm:text-lg leading-relaxed" style={{
          color: "hsl(0, 0%, 40%)"
        }}>
            Saluran komunikasi resmi untuk redaksi, kerjasama, dan layanan informasi publik ABADI.NEWS.
          </p>
        </div>

        {}
        <div ref={grid.ref} className={`mt-16 sm:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-700 ease-out delay-150 ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {channels.map((channel, i) => {
          const Icon = channel.icon;
          const isEmergency = channel.type === "emergency";
          return <div key={channel.type} data-index={i} className={`group relative flex flex-col rounded-lg p-10 lg:p-12 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${isEmergency ? "shadow-md" : "border bg-card shadow-sm"}`} style={isEmergency ? {
            backgroundColor: "hsl(27, 31%, 22%)",
            boxShadow: "0 0 0 1px hsla(25, 83%, 55%, 0.2), 0 10px 30px -10px hsla(27, 31%, 22%, 0.3)"
          } : {
            backgroundColor: "hsl(0, 0%, 100%)",
            borderColor: "hsl(0, 0%, 90%)"
          }}>
                {}
                <div className="mb-8">
                  <Icon className="h-12 w-12" strokeWidth={1.25} style={{
                color: isEmergency ? "hsl(25, 83%, 55%)" : "hsl(25, 83%, 55%)"
              }} aria-hidden="true" />
                </div>

                {}
                <p className="font-default text-xs tracking-[0.2em] uppercase mb-5" style={{
              color: isEmergency ? "hsl(25, 83%, 80%)" : "hsl(0, 0%, 40%)"
            }}>
                  {channel.label}
                </p>

                {}
                <h3 className="font-serif font-default text-2xl sm:text-[1.6rem] leading-tight mb-6" style={{
              color: isEmergency ? "hsl(0, 0%, 100%)" : "hsl(0, 0%, 0%)"
            }}>
                  {channel.heading}
                </h3>

                {}
                <Link to={channel.contactHref} className="font-serif font-default leading-tight break-words transition-opacity hover:opacity-80" style={{
              fontSize: channel.type === "email" ? "1.5rem" : "2rem",
              color: isEmergency ? "hsl(25, 83%, 55%)" : "hsl(25, 83%, 55%)"
            }}>
                  {channel.contact}
                </Link>

                {}
                <div className="mt-8 mb-5 h-px w-full" style={{
              backgroundColor: isEmergency ? "hsla(0, 0%, 100%, 0.15)" : "hsl(0, 0%, 90%)"
            }} />

                {}
                <p className="font-default text-sm leading-relaxed" style={{
              color: isEmergency ? "hsl(0, 0%, 80%)" : "hsl(0, 0%, 40%)"
            }}>
                  {channel.hours}
                </p>

                {}
                <span className="pointer-events-none absolute bottom-0 left-10 right-10 h-px origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100" style={{
              backgroundColor: "hsl(25, 83%, 55%)"
            }} aria-hidden="true" />
              </div>;
        })}
        </div>

        {}
        <div ref={footer.ref} className={`mt-16 sm:mt-20 flex items-center justify-center gap-3 transition-all duration-700 ease-out delay-300 ${footer.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75" style={{
            backgroundColor: "hsl(25, 83%, 55%)"
          }} />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-lg" style={{
            backgroundColor: "hsl(25, 83%, 55%)"
          }} />
          </span>
          <p className="font-serif font-default italic text-lg sm:text-xl" style={{
          color: "hsl(0, 0%, 0%)"
        }}>
            Redaksi kami siap melayani Anda.
          </p>
        </div>
      </div>
    </section>;
}